import { useEffect, useRef } from 'react';
import api from 'services/api';
import { useAddEventListener } from 'hooks/common';

const worker: Worker = new Worker('/worker/logout-worker.js');

export const useAutoLogout = () => {
  const handleAction = useRef(() => {
    worker.postMessage(null);
  });

  useEffect(() => {
    handleAction.current();
  }, []);

  useAddEventListener('click', handleAction.current);
  useAddEventListener('scroll', handleAction.current);
  useAddEventListener('keydown', handleAction.current);
  useAddEventListener('mousemove', handleAction.current);

  worker.onmessage = (e) => {
    api.logout();
    api.logoutApp();
  };
};
